/**
 * 리사이즈 가능한 사이드바 로직을 관리하는 Custom Hook
 * Single Responsibility: 사이드바 크기 조절만 담당
 */ import { useState, useEffect, useCallback } from 'react';
export const useResizableSidebar = (options = {})=>{
    const { defaultWidth = 350, minWidth = 250, maxWidth = 500, enableResize = false } = options;
    const [width, setWidth] = useState(defaultWidth);
    const [isResizing, setIsResizing] = useState(false);
    const handleResizeStart = useCallback((e)=>{
        if (!enableResize) return;
        e.preventDefault();
        e.stopPropagation();
        setIsResizing(true);
    }, [
        enableResize
    ]);
    useEffect(()=>{
        if (!isResizing) return;
        const handleMouseMove = (e)=>{
            const newWidth = window.innerWidth - e.clientX;
            if (newWidth >= minWidth && newWidth <= maxWidth) {
                setWidth(newWidth);
            }
        };
        const handleMouseUp = ()=>{
            setIsResizing(false);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        return ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
    }, [
        isResizing,
        minWidth,
        maxWidth
    ]);
    return {
        width,
        isResizing,
        handleResizeStart: enableResize ? handleResizeStart : undefined,
        resizeHandleProps: enableResize ? true : null // 단순히 표시 여부만 전달
    };
};
